module.exports = __webpack_public_path__ + "media/images/vrbo-7c3d5142.png";